var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-menu',{staticClass:"main-navigation",attrs:{"default-active":_vm.activePath,"unique-opened":""}},_vm._l((_vm.navs),function(nav,key){return _c(_vm.menuList(nav),{key:key,tag:"component",attrs:{"nav":nav}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }